<template>

  <div>

    <vs-popup id="select-color" :title="$t('MODULES.SelectStatusColor')" :active.sync="showAddColorsOptionModal">
      <div class="vx-row">
        <div class="vx-col w-full mt-2" style="margin-bottom: 50px!important;">
          <label class="vs-input--label">{{ $t("MODULES.color") }}</label>
          <v-select class="icon-select" v-model="colorOption" :options="colorOptions" label="name">
            <template v-slot:option="option">
              <div :class="'con-vs-chip vs-chip-' + option.color + ' con-color mr-4'
                " style="color: rgba(255, 255, 255, 0.9);">
                <span class="text-chip vs-chip--text"></span>
              </div>
              {{ option.name }}
            </template>
          </v-select>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:1/2 w-full mt-2">
          <vs-button class="ml-auto mt-2" @click="showAddColorsOptionModal = false">{{ $t("MODULES.confirm")
            }}</vs-button>
        </div>
      </div>
    </vs-popup>

    <form-wizard color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null" :finishButtonText="$t('MODULES.submit')"
      @on-complete="addFormSubmitted">
      <tab-content :title="$t('MODULES.basic_data')" class="mb-5" :before-change="validateStep1Add">
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <label class="vs-input--label">{{ $t("MODULES.type") }}</label>
            <v-select v-model="fieldData.type" class="field-type-select" :clearable="false"
              :options="fieldData.typeOptions" label="name" name="columnsOnForm" @input="onFieldTypeChange"
              :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <label class="vs-input--label">{{
              $t("MODULES.columns_in_form")
            }}</label>
            <v-select v-model="fieldData.columnsOnForm" :disabled="disableColumnsOnForm || fieldData.disableAll"
              :clearable="false" :options="fieldData.columnsOnFormOptions" name="columnsOnForm"
              :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mt-5">
            <vs-input :label="$t('MODULES.name')" v-model="fieldData.name" class="w-full"
              :disabled="fieldData.disableAll" />
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5">
            <vs-input :label="$t('MODULES.legend')" v-model="fieldData.subtitle" class="w-full"
              :disabled="fieldData.disableAll" />
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5">
            <ul class="switch-container">
              <li>
                <label class="vs-input--label">{{
                  $t("MODULES.showHint")
                }}</label>
                <vs-switch v-model="fieldData.showHint" class="mt-1 ml-1" :disabled="fieldData.disableAll" />
              </li>
            </ul>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldData.showHint">
            <vs-input v-if="fieldData.showHint" type="text" :label="$t('MODULES.hint')" v-model="fieldData.hint"
              class="w-full" :disabled="fieldData.disableAll" />
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldData.type.id === 31">
            <label class="vs-input--label">{{
              $t("MODULES.rows_per_page")
            }}</label>
            <v-select v-model="fieldData.rowsOnForm" :clearable="false" :options="fieldData.rowsOnFormOptions"
              name="rowsOnForm" :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="fieldData.disableAll" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mt-5"></div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mt-5"></div>
        </div>
      </tab-content>

      <tab-content title="Geral" class="mb-5" :before-change="validateStep2Add">
        <div class="vx-row mt-2 mb-2" v-if="fieldData.type.id === 31">
          <div class="vx-col md:w-1/2 w-full">
            <label class="vs-input--label">{{
              $t("MODULES.relatedToModule")
            }}</label>
            <v-select v-model="fieldData.relatedItemsModule" class="field-type-select" :clearable="false"
              :options="fieldData.relatedItemsModuleOptions" label="name" name="related-items-module"
              :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <label class="vs-input--label">{{ $t("MODULES.dependentOnList") }}</label>
            <v-select v-model="fieldData.picklistField" class="field-type-select" :clearable="true"
              :disabled="fieldData.picklistFieldOptions.length === 0" :options="fieldData.picklistFieldOptions"
              label="name" name="related-picklist" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <label class="vs-input--label">{{ $t("MODULES.dependentOnItem") }}</label>
            <v-select v-model="fieldData.picklistItem" class="field-type-select"
              :disabled="fieldData.picklistField === null || JSON.stringify(fieldData.picklistField) === '{}'"
              :clearable="true"
              :options="fieldData.picklistField === null || JSON.stringify(fieldData.picklistField) === '{}' ? [] : fieldData.picklistFieldItemsOptions[fieldData.picklistField.hash]"
              label="name" name="related-picklist-item" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
        </div>


        <div class="vx-row mt-2" v-if="fieldData.type.id === 25 || fieldData.type.id === 33">
          <div class="vx-col md:w-1/2 w-full">
            <label class="vs-input--label">{{
              $t("MODULES.relatedToModule")
            }}</label>
            <v-select v-model="fieldData.relatedModule" class="field-type-select" :clearable="false"
              :options="fieldData.moduleOptions" @input="onRelatedModuleChange" label="name" name="related-module"
              :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <label class="vs-input--label">{{
              $t("MODULES.relatedToField")
            }}</label>
            <v-select v-model="fieldData.relatedField" class="field-type-select" :clearable="false"
              :options="fieldData.moduleFieldOptions" label="name" name="related-module-field" @input="
                $event.id > 0
                  ? (fieldData.disableAll = false)
                  : (fieldData.disableAll = true)
                " :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
          <div class="vx-col mt-3 md:w-1/2 w-full">
            <label class="vs-input--label">{{
              $t("MODULES.dependsOnField")
            }}</label>
            <v-select v-model="fieldData.dependentField" class="field-type-select" :clearable="true"
              :options="fieldData.relatedFieldOptions" label="name" name="related-module-field"
              :disabled="fieldData.dependentDisable" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
        </div>

        <div class="vx-row" v-if="fieldData.type.id === 30">
          <div class="vx-col md:w-1/2 w-full">
            <label class="vs-input--label">{{
              $t("MODULES.relatedToKanban")
            }}</label>
            <v-select v-model="fieldData.relatedKanban" class="field-type-select" :clearable="false" :options="fieldData.moduleOptions.filter(
              x =>
                x.type === 6 && integratedKanbans.indexOf(x.hash) === -1
            )
              " label="name" name="related-kanban" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
        </div>

        <div class="vx-row mt-3" v-if="fieldData.type.id === 30 &&
          JSON.stringify(fieldData.relatedKanban) !== '{}'
        ">
          <div class="vx-col md:w-1/2 w-full">
            <label class="vs-input--label">{{
              $t("MODULES.selectTitleFieldInKanban")
            }}</label>
            <v-select v-model="fieldData.kanbanTitle" class="field-type-select" :clearable="false"
              :options="fieldsListToKanban" label="name" name="related-kanban" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <label class="vs-input--label">{{
              $t("MODULES.selectDescriptionFieldInKanban")
            }}</label>
            <v-select v-model="fieldData.kanbanDescription" class="field-type-select" :clearable="false"
              :options="fieldsListToKanban" label="name" name="related-kanban" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
        </div>

        <div class="vx-row mt-3" v-if="fieldData.type.id === 28">
          <div class="vx-col md:w-1/2 w-full">
            <label class="vs-input--label">{{
              $t("MODULES.selectFieldForDocumentName")
            }}</label>
            <v-select v-model="fieldData.documentNameField" class="field-type-select" :clearable="false"
              :options="fieldsListToDocumentName" label="name" name="related-document-name"
              :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
        </div>

        <div class="vx-row" v-if="fieldData.type.id == 24">
          <div class="vx-col md:w-1/2 w-full">
            <h6 class="mt-5 mb-3">{{ $t("MODULES.insertItem") }}</h6>
            <vx-input-group class="mb-base mt-5">
              <vs-input v-model="optionValue" maxlength="100" @keypress.enter="addOptionAddForm" />
              <template slot="append">
                <div class="append-text btn-addon">
                  <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus"
                    @click="addOptionAddForm"></vs-button>
                </div>
              </template>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <h6 class="mt-5 mb-3">{{ $t("MODULES.ItemsInList") }}</h6>
            <draggable :list="fieldData.options" :group="{ name: 'tags', pull: 'clone', put: false }"
              class="p-2 cursor-move">
              <vs-chip color="primary"
                style="padding-left: 20px!important; padding-right: 20px!important;font-size: 1.0rem!important; min-width: 70px!important; min-height: 35px!important;"
                v-for="(listItem, index) in fieldData.options" :key="index">
                <feather-icon icon="XIcon" svgClasses="h-4 w-4 text-outline" class="mr-3"
                  @click="removeItemAddForm(index)"
                  style="cursor: pointer!important; margin-left: -10px!important;"></feather-icon>
                {{ listItem }}
              </vs-chip>
            </draggable>
          </div>
        </div>
        <div class="vx-row" v-if="fieldData.type.id == 32">
          <div class="vx-col md:w-1/2 w-full">
            <h6 class="mt-5 mb-3">{{ $t("MODULES.insertItem") }}</h6>
            <vx-input-group class="mb-base mt-5">
              <vs-input v-model="optionValue" maxlength="100" @keypress.enter="addOptionAddForm" />
              <template slot="append">
                <div class="append-text btn-addon">
                  <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus"
                    @click="addOptionAddForm"></vs-button>
                </div>
              </template>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <h6 class="mt-5 mb-3">{{ $t("MODULES.ItemsInList") }}</h6>
            <draggable :list="fieldData.options" :group="{ name: 'tags', pull: 'clone', put: false }"
              class="p-2 cursor-move">
              <vs-chip color="primary"
                style="padding-left: 20px!important; padding-right: 20px!important;font-size: 1.0rem!important; min-width: 70px!important; min-height: 35px!important;"
                v-for="(listItem, index) in fieldData.options" :key="index">
                <feather-icon icon="XIcon" svgClasses="h-4 w-4 text-outline" class="mr-3"
                  @click="removeItemAddForm(index)"
                  style="cursor: pointer!important; margin-left: -10px!important;"></feather-icon>
                {{ listItem }}
              </vs-chip>
            </draggable>
          </div>
        </div>
        <div class="vx-row" v-if="fieldData.type.id == 29">
          <div class="vx-col md:w-1/2 w-full">
            <h6 class="mt-5 mb-3">{{ $t("MODULES.insertItem") }}</h6>
            <vx-input-group class="mb-base mt-5">
              <vs-input v-model="optionValue" maxlength="100" @keypress.enter="addOptionAddForm(fieldData.type.id)" />
              <template slot="append">
                <div class="append-text btn-addon">
                  <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus"
                    @click="addOptionAddForm(fieldData.type.id)"></vs-button>
                </div>
              </template>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <h6 class="mt-5 mb-3">{{ $t("MODULES.ItemsInList") }}</h6>
            <draggable :list="fieldData.options" :group="{ name: 'tags', pull: 'clone', put: false }"
              class="p-2 cursor-move">
              <vs-chip :color="listItem.color || 'primary'"
                style="padding-left: 20px!important; padding-right: 20px!important;font-size: 1.0rem!important; min-width: 70px!important; min-height: 35px!important;"
                v-for="(listItem, index) in fieldData.options" :key="index">
                <feather-icon icon="XIcon" svgClasses="h-4 w-4 text-outline" class="mr-3"
                  @click="removeItemAddForm(index)"
                  style="cursor: pointer!important; margin-left: -10px!important;"></feather-icon>
                {{ listItem.value }}
              </vs-chip>
            </draggable>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mt-5" v-if="showPlaceholder.includes(fieldData.type.id)">
            <vs-input type="text" :label="$t('MODULES.placeholder')" v-model="fieldData.placeholder" class="w-full"
              :disabled="fieldData.disableAll" />
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5" v-if="fieldData.type.id === $FIELD_TYPES.PUSH_TAGS_LIST">
            <vs-input type="text" :label="'Match pattern (javascript regex)'" v-model="fieldData.matchPattern"
              class="w-full" :disabled="fieldData.disableAll" />
          </div>
          <div class="vx-col mt-5" v-if="fieldData.type.id === 20 || fieldData.type.id === 18">
            <label class="vs-input--label">
              {{ $t("MODULES.decimalPlaces") }}
            </label>
            <vs-input-number v-model="fieldData.decimals" :disabled="fieldData.disableAll" min="1" max="6" />
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5" v-if="fieldData.type.id === 1 ||
            fieldData.type.id === 2 ||
            fieldData.type.id === 3 ||
            fieldData.type.id === 16 ||
            fieldData.type.id === 19 ||
            fieldData.type.id === 23
          ">
            <vs-input type="text" v-if="fieldData.type.id === 1 ||
              fieldData.type.id === 2 ||
              fieldData.type.id === 3 ||
              fieldData.type.id === 16 ||
              fieldData.type.id === 19
            " label="Valor Padrão" v-model="fieldData.defaultValue" class="w-full" :disabled="fieldData.disableAll" />
            <ul class="switch-container" v-else-if="fieldData.type.id === 23">
              <li>
                <label class="vs-input--label">{{
                  $t("MODULES.defaultValue")
                }}</label>
                <vs-switch v-model="fieldData.defaultValue" class="mt-1 ml-1" />
              </li>
            </ul>
          </div>
          <!-- <div class="vx-row" v-if="fieldData.type.id == 24 || fieldData.type.id == 29"> -->
          <div class="vx-col md:w-1/2 w-full" v-if="fieldData.type.id == 24 || fieldData.type.id == 29">
            <label class="vs-input--label">{{
              $t("MODULES.defaultValue")
            }}</label>
            <v-select v-model="fieldData.defaultValue" :clearable="true" :options="fieldData.options" label="value"
              name="default-value" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
          <!-- </div> -->
          <!-- Min And Max -->
          <div class="vx-col md:w-1/2 w-full mt-5" v-show="showMinAndMaxValueInt.includes(fieldData.type.id)">
            <vs-input type="number" :label="$t('MODULES.minValue')" v-model="fieldData.minValueInt" class="w-full"
              :disabled="fieldData.disableAll" />
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5" v-show="showMinAndMaxValueInt.includes(fieldData.type.id)">
            <vs-input type="number" :label="$t('MODULES.maxValue')" v-model="fieldData.maxValueInt" class="w-full"
              :disabled="fieldData.disableAll" />
          </div>

          <div class="vx-col md:w-1/2 w-full mt-5" v-show="showMinAndMaxValueDate.includes(fieldData.type.id)">
            <label class="vs-input--label">
              {{ $t("MODULES.minValue") }}
            </label>
            <flat-pickr v-model="fieldData.minValueDate" :config="{ dateFormat: 'd/m/Y' }" class="w-full" name="dob" />
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5" v-show="showMinAndMaxValueDate.includes(fieldData.type.id)">
            <label class="vs-input--label">
              {{ $t("MODULES.maxValue") }}
            </label>
            <flat-pickr v-model="fieldData.maxValueDate" :config="{ dateFormat: 'd/m/Y' }" class="w-full" name="dob" />
          </div>

          <div class="vx-col md:w-1/2 w-full mt-5" v-show="showMinAndMaxValueDateTime.includes(fieldData.type.id)">
            <label class="vs-input--label">
              {{ $t("MODULES.minValue") }}
            </label>
            <flat-pickr v-model="fieldData.minValueDateTime" :config="{
              dateFormat: 'd/m/Y H:i:S',
              enableTime: true,
              enableSeconds: true,
              time_24hr: true
            }" class="w-full" name="dob" />
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5" v-show="showMinAndMaxValueDateTime.includes(fieldData.type.id)">
            <label class="vs-input--label">
              {{ $t("MODULES.maxValue") }}
            </label>
            <flat-pickr v-model="fieldData.maxValueDateTime" :config="{
              dateFormat: 'd/m/Y H:i:S',
              enableTime: true,
              enableSeconds: true,
              time_24hr: true
            }" class="w-full" name="dob" />
          </div>

          <!-- Min And Max -->
          <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldData.type.id === 1">
            <label class="vs-input--label">
              {{ $t('MODULES.mask') }}
            </label>
            <v-select v-model="fieldData.mask" :disabled="fieldData.disableAll" multiple taggable push-tags />
            <!-- <vs-input
                type="text"
                :label="$t('MODULES.mask')"
                v-model="fieldData.mask"
                class="w-full"
                :disabled="fieldData.disableAll"
              /> -->
          </div>

          <div class="vx-col md:w-1/2 w-full mt-5" v-show="showLengthField.includes(fieldData.type.id)">

            <ul class="switch-container">
              <li>
                <label class="vs-input--label">{{
                  $t("MODULES.saveMask")
                }}</label>
                <vs-switch v-model="fieldData.saveMask" class="mt-1 ml-1" />
              </li>
            </ul>

          </div>


          <div class="vx-col md:w-1/2 w-full mt-5" v-show="showLengthField.includes(fieldData.type.id)">
            <vs-input type="number" :label="$t('MODULES.size')" v-model="fieldData.length" class="w-full"
              :disabled="fieldData.disableAll" />
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5">
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5" v-show="(fieldData.type.id >= 4 && fieldData.type.id <= 15) ||
            (fieldData.type.id >= 17 && fieldData.type.id <= 19)
            ">
          </div>


          <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldData.type.id === 25">
            <ul class="switch-container">
              <li>
                <label class="vs-input--label">{{
                  $t("MODULES.showRelatedTab")
                }}</label>
                <vs-switch v-model="fieldData.relatedTab" class="mt-1 ml-1" />
              </li>
            </ul>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldData.type.id === 25 && fieldData.showRelatedTabName">
            <vs-input type="text" :label="$t('MODULES.tabName')" v-model="fieldData.relatedTabName" class="w-full" />
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldData.type.id === 25 && fieldData.showRelatedTabName">
            <vs-input type="text" :label="$t('MODULES.tabNameEn')" v-model="fieldData.relatedTabNameEn" class="w-full" />
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldData.type.id === 30">
            <ul class="switch-container">
              <li>
                <label class="vs-input--label">{{
                  $t("MODULES.showFooter")
                }}</label>
                <vs-switch v-model="fieldData.showFooter" class="mt-1 ml-1" />
              </li>
            </ul>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5" v-show="!hideQuickCreate.includes(fieldData.type.id)">
            <ul class="switch-container">
              <li>
                <label class="vs-input--label">{{
                  $t("MODULES.quickCreation")
                }}</label>
                <vs-switch v-model="fieldData.quickCreate" class="mt-1 ml-1" />
              </li>
            </ul>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5" v-show="!hideMassEdit.includes(fieldData.type.id)">
            <ul class="switch-container">
              <li>
                <label class="vs-input--label">{{
                  $t("MODULES.massEdit")
                }}</label>
                <vs-switch v-model="fieldData.massEdit" class="mt-1 ml-1" />
              </li>
            </ul>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5" v-show="!hideCallApi.includes(fieldData.type.id)">
            <ul class="switch-container">
              <li>
                <label class="vs-input--label">{{
                  $t("MODULES.performApiQuery")
                }}</label>
                <vs-switch v-model="fieldData.callApi" class="mt-1 ml-1" />
              </li>
            </ul>
          </div>
          <div class="vx-col mt-5" v-show="!hideCallApi.includes(fieldData.type.id)">
            <label class="vs-input--label">{{
              $t("MODULES.maxTimeout")
            }}</label>
            <vs-input-number v-model="fieldData.minimalTimeout" min="3" max="60" />
          </div>
          <div class="vx-col mt-5" v-show="fieldData.type_id === $FIELD_TYPES.PUSH_TAGS_LIST">
            <label class="vs-input--label">{{
              $t("MODULES.maxTimeout")
            }}</label>
            <vs-input-number v-model="fieldData.minimalTimeout" min="3" max="60" />
          </div>
          {{ fieldData.type_id }}
          <div class="vx-col md:w-1/2 w-full mt-5"
            v-show="(fieldData.type.id >= 3 && fieldData.type.id <= 18) || fieldData.type.id === 35">
            <ul class="switch-container">
              <li>
                <label class="vs-input--label">{{
                  $t("MODULES.ShowIcon")
                }}</label>
                <vs-switch v-model="fieldData.showIcon" class="mt-1 ml-1" />
              </li>
            </ul>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5">
            <ul class="switch-container">
              <li>
                <label class="vs-input--label">{{
                  $t("MODULES.mandatory")
                }}</label>
                <vs-switch v-model="fieldData.mandatory" class="mt-1 ml-1" />
              </li>
            </ul>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5">
            <ul class="switch-container">
              <li>
                <label class="vs-input--label">{{
                  $t("MODULES.fullLine")
                }}</label>
                <vs-switch v-model="fieldData.entireLine" class="mt-1 ml-1" />
              </li>
            </ul>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5" v-show="!hideUnique.includes(fieldData.type.id)">
            <ul class="switch-container">
              <li>
                <label class="vs-input--label">{{
                  $t("MODULES.uniqueValue")
                }}</label>
                <vs-switch v-model="fieldData.unique" class="mt-1 ml-1" />
              </li>
            </ul>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5" v-show="showSecretField.includes(fieldData.type.id)">
            <ul class="switch-container">
              <li>
                <label class="vs-input--label">{{
                  $t("MODULES.secret")
                }}</label>
                <vs-switch v-model="fieldData.secret" class="mt-1 ml-1" />
              </li>
            </ul>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5" v-show="!hideDisabled.includes(fieldData.type.id)">
            <ul class="switch-container">
              <li>
                <label class="vs-input--label">{{
                  $t("MODULES.disabled")
                }}</label>
                <vs-switch v-model="fieldData.isDisabled" class="mt-1 ml-1" />
              </li>
            </ul>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5" v-show="!unavailableSearchTypes.includes(fieldData.type.id)">
            <ul class="switch-container">
              <li>
                <label class="vs-input--label">{{
                  $t("MODULES.enableSearch")
                }}</label>
                <vs-switch v-model="fieldData.isSearchField" class="mt-1 ml-1" />
              </li>
            </ul>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5" v-show="availableConcatIdentifierTypes.includes(fieldData.type.id)">
            <ul class="switch-container">
              <li>
                <label class="vs-input--label">{{
                  $t("MODULES.concatIdentifier")
                }}</label>
                <vs-switch v-model="fieldData.concatIdentifier" class="mt-1 ml-1" />
              </li>
            </ul>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5" v-show="[12, 13, 35].includes(fieldData.type.id)">
              <ul class="switch-container">
                <li>
                  <label class="vs-input--label">{{
                    $t("MODULES.allowPastDates")
                    }}</label>
                  <vs-switch v-model="fieldData.allowPastDates" class="mt-1 ml-1" />
                </li>
              </ul>
            </div>
          <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldData.type.id === 16">
            <ul class="switch-container">
              <li>
                <label class="vs-input--label">{{
                  $t("MODULES.showProgressBar")
                }}</label>
                <vs-switch v-model="fieldData.showProgressBar" class="mt-1 ml-1" />
              </li>
            </ul>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5"></div>
          <div class="vx-col md:w-1/2 w-full mt-5"></div>
        </div>
      </tab-content>

      <!-- tab 2 content -->
      <tab-content :title="$t('MODULES.permissions')" class="mb-5">
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="flex items-end px-3">
              <feather-icon svgClasses="w-6 h-6" icon="LockIcon" class="mr-2" />
              <span class="font-medium text-lg leading-none">{{
                $t("MODULES.selectFieldPermissionForRoles")
                }}</span>
            </div>
            <div style="float: right;">
              <div style="float: left; margin-right: 12px;">
                <div style="float: left; margin-right: 6px;">
                  <feather-icon icon="CircleIcon" :svgClasses="['fill-current h-4 w-4 text-dark']" />
                </div>
                <div style="float: left;">
                  <span>{{ $t("MODULES.hidden") }}</span>
                </div>
              </div>
              <div style="float: left; margin-right: 12px;">
                <div style="float: left; margin-right: 6px;">
                  <feather-icon icon="CircleIcon" :svgClasses="['fill-current h-4 w-4 text-primary']" />
                </div>
                <div style="float: left;">
                  <span>{{ $t("MODULES.readOnly") }}</span>
                </div>
              </div>
              <div style="float: left; margin-right: 12px;">
                <div style="float: left; margin-right: 6px;">
                  <feather-icon icon="CircleIcon" :svgClasses="['fill-current h-4 w-4 text-success']" />
                </div>
                <div style="float: left;">
                  <span>{{ $t("MODULES.write") }}</span>
                </div>
              </div>
            </div>
            <vs-divider />
          </div>
        </div>
        <vs-table :data="roleListSliced">
          <template>
            <vs-tr v-for="roleItem in roleListSliced" :key="roleItem.hash">
              <vs-td v-for="role in roleItem" :key="role.hash" style="width: 33.3%!important;">
                <label class="vs-input--label" style="font-size: 15px;">{{
                  role.name
                  }}</label>
                <div>
                  <div>
                    <vs-slider max="2" :id="`slider-${role.hash}`" v-model="rolePermissions[role.hash]"
                      @input="sliderChange(`${role.hash}`, $event)"
                      style="width: 12% !important; min-width: 0px !important; float: left;" />
                  </div>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </tab-content>
    </form-wizard>

  </div>


</template>

<script>
import vSelect from 'vue-select'

// Store Module
import draggable from 'vuedraggable'
import { FormWizard, TabContent } from 'vue-form-wizard'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { PlusCircleIcon } from 'vue-feather-icons'
import AddModuleFieldModal from './AddModuleFieldModal.vue'
import { performFetch } from '../../../helpers.js'
export default {
  components: {
    vSelect,
    draggable,
    FormWizard,
    TabContent,
    PlusCircleIcon,
    flatPickr,
    AddModuleFieldModal
  },
  props: {
    addFieldPopUpActive: {
      type: Boolean,
      default: false
    },
    fieldData: {
      type: Object,
      default: {}
    },
    rolePermissions: {
      type: Object,
      default: {}
    },
    roleListSliced: [],
    currentBlockToAddField: ''
  },
  watch: {
    showAddColorsOptionModal (value) {
      if (!value) {
        if (JSON.stringify(this.colorOption) === '{}') {
          this.$vs.notify({
            title: this.$t('MODULES.hashInvalidTitle'),
            text: 'O item precisa ter uma cor anexada!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })

          this.showAddColorsOptionModal = true
        } else {
          this.addOptionAddForm(29, true)
        }
      }
    }
  },
  data () {
    return {
      optionValue: '',
      colorOption: {},
      showPlaceholder: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20
      ],
      disableColumnsOnForm: false,
      unavailableSearchTypes: [21, 22, 27, 28, 2, 16, 17, 18, 20, 31, 34, 40],
      availableConcatIdentifierTypes: [this.$FIELD_TYPES.RELATED_TO_A_MODULE, this.$FIELD_TYPES.RELATED_TO_A_MODULE_MULTIPLE],
      showMinAndMaxValueInt: [2],
      showMinAndMaxValueDate: [12],
      showMinAndMaxValueDateTime: [13],
      showMinAndMaxValueTime: [],
      showLengthField: [1, 19],
      showAddColorsOptionModal: false,
      showEditColorsOptionModal: false,
      hideQuickCreate: [21, 22, 31],
      hideMassEdit: [21, 22, 31],
      hideCallApi: [21, 22, 31],
      hideMandatory: [31],
      hideEntireLine: [],
      showSecretField: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 14, 15, 16, 18, 20],
      hideUnique: [21, 22, 31, 40],
      hideDisabled: [31],
      colorOptions: [
        {
          color: 'danger',
          name: 'Vermelho'
        },
        {
          color: 'warning',
          name: 'Amarelo'
        },
        {
          color: 'success',
          name: 'Verde'
        }
      ],
      // default parameters
      picklistFields: [],
      picklistFieldItems: {}
    }
  },
  mounted () {
    console.log('here!!!')
  },
  methods: {
    resetProps () {
      this.$emit('reset-props')
    },
    addOptionAddForm (fieldTypeId = null, submit = false) {
      if (fieldTypeId === 29 && !submit) {
        this.showAddColorsOptionModal = true

        if (this.optionValue === '') {
          this.$vs.notify({
            title: this.$t('MODULES.hashInvalidTitle'),
            text: this.$t('MODULES.emptyItem'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        }
      } else if (fieldTypeId === 29 && submit) {
        if (this.fieldData.options[0].value === 'Adicione um item...') {
          this.fieldData.options = []
        }
        this.fieldData.options.push({
          color: this.colorOption.color,
          value: this.optionValue
        })
        this.optionValue = ''
        this.colorOption = {}
        this.showAddColorsOptionModal = false
      } else if (this.optionValue !== '') {
        if (this.fieldData.options[0] === 'Adicione um item...') {
          this.fieldData.options = []
        }
        this.fieldData.options.push(this.optionValue)
        this.optionValue = ''
      } else {
        this.$vs.notify({
          title: this.$t('MODULES.hashInvalidTitle'),
          text: this.$t('MODULES.emptyItem'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      }
    },
    async onRelatedModuleChange (val) {
      this.getRelatedFields(this.$route.params.moduleHash, val.hash, 'add')

      this.$vs.loading({ type: 'default' })

      await performFetch(this.$store.state.auth.api_url, {
        command: 'module_management_get_application_module_fields',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: val.hash
        }
      })
        .then(async response => {
          this.$vs.loading.close()
          if (response.status === 200) {
            response.json().then(responseData => {
              const moduleFieldList = []

              responseData.module.payload.forEach(item => {
                item.fields.forEach(fieldItem => {
                  const fieldObject = {
                    hash: fieldItem.hash,
                    name: `${item.title} - ${fieldItem.title}`
                  }

                  if (
                    fieldItem.type_id !== 24 &&
                    fieldItem.type_id !== 25 &&
                    fieldItem.type_id !== 32 &&
                    fieldItem.type_id !== 33
                  ) {
                    moduleFieldList.push(fieldObject)
                  }
                })
              })

              moduleFieldList.sort((a, b) => {
                if (a.name < b.name) {
                  return -1
                }
                if (a.name > b.name) {
                  return 1
                }
                return 0
              })

              this.fieldData.moduleFieldOptions = moduleFieldList

              this.$vs.loading.close()
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem(
              'lastUrl',
              btoa(window.location.pathname)
            )
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: this.$t('MODULES.FailedOperation'),
              text: this.$t('MODULES.errorSearchModulos'),
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'danger'
            })
          }
        })
        .catch(e => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('MODULES.FailedOperation'),
            text: this.$t('MODULES.errorSearchModulos'),
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    async getRelatedFields (moduleToken, relatedModuleToken, action = 'add') {
      await performFetch(this.$store.state.auth.api_url, {
        command: 'get_module_related_fields',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: moduleToken,
          related_module_token: relatedModuleToken
        }
      })
        .then(async response => {
          this.$vs.loading.close()
          if (response.status === 200) {
            response.json().then(responseData => {
              const relatedFields = []

              responseData.payload.forEach(item => {
                const fieldObject = {
                  hash: item.hash,
                  name: item.name
                }

                relatedFields.push(fieldObject)
              })

              relatedFields.sort((a, b) => {
                if (a.name < b.name) {
                  return -1
                }
                if (a.name > b.name) {
                  return 1
                }
                return 0
              })

              if (action === 'add') {
                this.fieldData.relatedFieldOptions = relatedFields

                if (
                  Array.isArray(this.fieldData.relatedFieldOptions) &&
                  this.fieldData.relatedFieldOptions.length > 0
                ) {
                  this.fieldData.dependentDisable = false
                } else {
                  this.fieldData.dependentDisable = true
                }

                this.fieldData.dependentField = {}
              } else {
                this.fieldEditData.relatedFieldOptions = relatedFields

                if (
                  Array.isArray(this.fieldEditData.relatedFieldOptions) &&
                  this.fieldEditData.relatedFieldOptions.length > 0
                ) {
                  this.fieldEditData.dependentDisable = false
                } else {
                  this.fieldEditData.dependentDisable = true
                }
              }

              this.$vs.loading.close()
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem(
              'lastUrl',
              btoa(window.location.pathname)
            )
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: this.$t('MODULES.FailedOperation'),
              text: this.$t('MODULES.errorSearchModulos'),
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'danger'
            })
          }
        })
        .catch(e => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('MODULES.FailedOperation'),
            text: this.$t('MODULES.errorSearchModulos'),
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    async validateStep2Add () {
      if (this.fieldData.type.id === 31) {
        if (
          this.fieldData.relatedItemsModule === null ||
          JSON.stringify(this.fieldData.relatedItemsModule) === '{}'
        ) {
          this.$vs.notify({
            title: this.$t('MODULES.hashInvalidTitle'),
            text: this.$t('MODULES.relatedModuleRequired'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })

          return false
        }

        const hasQuickCreateFields = await this.checkIfModuleHasQuickCreateFields(
          this.fieldData.relatedItemsModule.hash
        )

        if (!hasQuickCreateFields) {
          this.$vs.notify({
            title: this.$t('MODULES.hashInvalidTitle'),
            text: this.$t('MODULES.noQuickCreateFields'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })

          return false
        }
      }

      // if(this.fieldData.type.id === 28) {
      //   if(!this.fieldData.documentNameField || JSON.stringify(this.fieldData.documentNameField) === '{}') {
      //     this.$vs.notify({
      //       title: this.$t('MODULES.hashInvalidTitle'),
      //       text: 'O campo!',
      //       iconPack: 'feather',
      //       icon: 'icon-alert-circle',
      //       color: 'warning'
      //     })

      //     return false
      //   }
      // }

      if (this.fieldData.type.id === 2) {
        if (this.fieldData.defaultValue && this.fieldData.defaultValue !== '') {
          let value = null

          value = parseInt(this.fieldData.defaultValue)

          if (isNaN(value)) {
            this.$vs.notify({
              title: this.$t('MODULES.hashInvalidTitle'),
              text: this.$t('MODULES.defaultNumeric'),
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })

            return false
          }

          if (
            this.fieldData.minValueInt &&
            value !== null &&
            value < this.fieldData.minValueInt
          ) {
            this.$vs.notify({
              title: this.$t('MODULES.hashInvalidTitle'),
              text: this.$t('MODULES.minMaxCriteria'),
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })

            return false
          }

          if (
            this.fieldData.maxValueInt &&
            value !== null &&
            value > this.fieldData.maxValueInt
          ) {
            this.$vs.notify({
              title: this.$t('MODULES.hashInvalidTitle'),
              text: this.$t('MODULES.minMaxCriteria'),
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })

            return false
          }
        }
      }

      if (
        this.fieldData.picklistFieldOptions.length > 0 &&
        this.fieldData.picklistField !== null &&
        JSON.stringify(this.fieldData.picklistField) !== '{}' &&
        (this.fieldData.picklistItem === null ||
          JSON.stringify(this.fieldData.picklistItem) === '{}')
      ) {
        this.$vs.notify({
          title: this.$t('MODULES.hashInvalidTitle'),
          text: this.$t('MODULES.selectListItem'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (
        this.fieldData.type.id === 24 &&
        (this.fieldData.options.length === 0 ||
          (this.fieldData.options.length === 1 &&
            this.fieldData.options[0] === 'Adicione um item...'))
      ) {
        this.$vs.notify({
          title: this.$t('MODULES.hashInvalidTitle'),
          text: this.$t('MODULES.minOneItem'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (
        this.fieldData.type.id === 32 &&
        (this.fieldData.options.length === 0 ||
          (this.fieldData.options.length === 1 &&
            this.fieldData.options[0] === 'Adicione um item...'))
      ) {
        this.$vs.notify({
          title: this.$t('MODULES.hashInvalidTitle'),
          text: this.$t('MODULES.minOneItem'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (
        this.fieldData.type.id === 29 &&
        (this.fieldData.defaultValue === null ||
          JSON.stringify(this.fieldData.defaultValue) === '{}')
      ) {
        this.$vs.notify({
          title: this.$t('MODULES.hashInvalidTitle'),
          text: this.$t('MODULES.statusDefaultValue'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (
        this.fieldData.type.id === 29 &&
        (this.fieldData.options.length === 0 ||
          (this.fieldData.options.length === 1 &&
            this.fieldData.options[0]['value'] === 'Adicione um item...'))
      ) {
        this.$vs.notify({
          title: this.$t('MODULES.hashInvalidTitle'),
          text: this.$t('MODULES.minOneItem'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (
        this.fieldData.type.id === 30 &&
        JSON.stringify(this.fieldData.relatedKanban) === '{}'
      ) {
        this.$vs.notify({
          title: this.$t('MODULES.hashInvalidTitle'),
          text: this.$t('MODULES.chooseKanbanModule'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (
        this.fieldData.type.id === 30 &&
        JSON.stringify(this.fieldData.kanbanTitle) === '{}'
      ) {
        this.$vs.notify({
          title: this.$t('MODULES.hashInvalidTitle'),
          text: this.$t('MODULES.chooseTitleField'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (
        this.fieldData.type.id === 30 &&
        JSON.stringify(this.fieldData.kanbanDescription) === '{}'
      ) {
        this.$vs.notify({
          title: this.$t('MODULES.hashInvalidTitle'),
          text: this.$t('MODULES.chooseDescriptionField'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (
        this.showLengthField.includes(this.fieldData.type.id) &&
        (parseInt(this.fieldData.length) > 3000 ||
          parseInt(this.fieldData.length) < 0) &&
        (this.fieldData.length !== '' ||
          this.fieldData.length !== null ||
          this.fieldData.length === 'e')
      ) {
        this.$vs.notify({
          title: this.$t('MODULES.hashInvalidTitle'),
          text: this.$t('MODULES.sizeRange'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (
        this.fieldData.type.id === 25 &&
        !(
          Object.keys(this.fieldData.relatedModule).length === 0 &&
          this.fieldData.relatedModule.constructor === Object
        ) &&
        Object.keys(this.fieldData.relatedField).length === 0 &&
        this.fieldData.relatedField.constructor === Object
      ) {
        this.$vs.notify({
          title: this.$t('MODULES.hashInvalidTitle'),
          text: this.$t('MODULES.relatedFieldRequired'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (
        this.fieldData.type.id === 33 &&
        !(
          Object.keys(this.fieldData.relatedModule).length === 0 &&
          this.fieldData.relatedModule.constructor === Object
        ) &&
        Object.keys(this.fieldData.relatedField).length === 0 &&
        this.fieldData.relatedField.constructor === Object
      ) {
        this.$vs.notify({
          title: this.$t('MODULES.hashInvalidTitle'),
          text: this.$t('MODULES.relatedFieldRequired'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (
        this.fieldData.type.id === 25 &&
        Object.keys(this.fieldData.relatedModule).length === 0 &&
        this.fieldData.relatedModule.constructor === Object
      ) {
        this.$vs.notify({
          title: this.$t('MODULES.hashInvalidTitle'),
          text: this.$t('MODULES.relatedModuleRequired'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (
        this.fieldData.type.id === 33 &&
        Object.keys(this.fieldData.relatedModule).length === 0 &&
        this.fieldData.relatedModule.constructor === Object
      ) {
        this.$vs.notify({
          title: this.$t('MODULES.hashInvalidTitle'),
          text: this.$t('MODULES.relatedModuleRequired'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (this.showMinAndMaxValueInt.includes(this.fieldData.type.id)) {
        if (this.fieldData.minValueInt && this.fieldData.maxValueInt) {
          if (
            parseInt(this.fieldData.minValueInt) >
            parseInt(this.fieldData.maxValueInt)
          ) {
            this.$vs.notify({
              title: this.$t('MODULES.hashInvalidTitle'),
              text: this.$t('MODULES.minMaxValueError'),
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })

            return false
          }

          this.fieldData.minValue = this.fieldData.minValueInt
          this.fieldData.maxValue = this.fieldData.maxValueInt
        }
      } else if (this.showMinAndMaxValueDate.includes(this.fieldData.type.id)) {
        if (this.fieldData.minValueDate && this.fieldData.maxValueDate) {
          let minValueDateStr = ''
          let maxValueDateStr = ''

          try {
            minValueDateStr = `${this.fieldData.minValueDate.split('/')[2]}-${this.fieldData.minValueDate.split('/')[1]
            }-${this.fieldData.minValueDate.split('/')[0]}`
          } catch (e) {
            console.error(e)
          }

          try {
            maxValueDateStr = `${this.fieldData.maxValueDate.split('/')[2]}-${this.fieldData.maxValueDate.split('/')[1]
            }-${this.fieldData.maxValueDate.split('/')[0]}`
          } catch (e) {
            console.error(e)
          }

          if (minValueDateStr && maxValueDateStr) {
            const minValueDateObject = new Date(minValueDateStr)
            const maxValueDateObject = new Date(maxValueDateStr)

            if (minValueDateObject > maxValueDateObject) {
              this.$vs.notify({
                title: this.$t('MODULES.hashInvalidTitle'),
                text: this.$t('MODULES.minMaxValueError'),
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
              })

              return false
            }
          }

          this.fieldData.minValue = minValueDateStr
          this.fieldData.maxValue = maxValueDateStr
        }
      } else if (
        this.showMinAndMaxValueDateTime.includes(this.fieldData.type.id)
      ) {
        if (
          this.fieldData.minValueDateTime &&
          this.fieldData.maxValueDateTime
        ) {
          let minValueDateStr = ''
          let maxValueDateStr = ''

          const minTime = this.fieldData.minValueDateTime.split(' ')[1].trim()
          const minDate = this.fieldData.minValueDateTime.split(' ')[0].trim()
          const maxTime = this.fieldData.maxValueDateTime.split(' ')[1].trim()
          const maxDate = this.fieldData.maxValueDateTime.split(' ')[0].trim()

          try {
            minValueDateStr = `${minDate.split('/')[2]}-${minDate.split('/')[1]
            }-${minDate.split('/')[0]}`
          } catch (e) { }

          try {
            maxValueDateStr = `${maxDate.split('/')[2]}-${maxDate.split('/')[1]
            }-${maxDate.split('/')[0]}`
          } catch (e) { }

          if (minValueDateStr && maxValueDateStr) {
            const minValueDateObject = new Date(
              `${minValueDateStr} ${minTime}`
            )
            const maxValueDateObject = new Date(
              `${maxValueDateStr} ${maxTime}`
            )

            if (minValueDateObject > maxValueDateObject) {
              this.$vs.notify({
                title: this.$t('MODULES.hashInvalidTitle'),
                text: this.$t('MODULES.minMaxValueError'),
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
              })

              return false
            }
          }

          this.fieldData.minValue = `${minValueDateStr} ${minTime}`
          this.fieldData.maxValue = `${maxValueDateStr} ${maxTime}`
        }
      }

      return true
    },
    async onFieldTypeChange (val) {
      val.id > 0
        ? (this.fieldData.disableAll = false)
        : (this.fieldData.disableAll = true)

      if (val.id === 31) {
        this.fieldData.columnsOnForm = 4
        this.disableColumnsOnForm = true
      } else {
        this.fieldData.columnsOnForm = 1
        this.disableColumnsOnForm = false
      }

      if (val.id === 25 || val.id === 30 || val.id === 33) {
        await performFetch(this.$store.state.auth.api_url, {
          command: 'module_management_get_application_modules',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token
          }
        })
          .then(async response => {
            this.$vs.loading.close()
            if (response.status === 200) {
              this.fieldData.moduleOptions = []

              response.json().then(responseData => {
                // this.fieldData.moduleOptions = responseData.modules

                responseData.modules.forEach(item => {
                  if (item.hash !== this.$route.params.moduleHash) {
                    const moduleObject = {
                      hash: item.hash,
                      name: item.name,
                      type: item.type.id
                    }

                    this.fieldData.moduleOptions.push(moduleObject)
                  }
                })
              })
            } else if (response.status == 401) {
              setApplicationLocalStorageItem(
                'lastUrl',
                btoa(window.location.pathname)
              )
              this.$store.dispatch('auth/signOut')
            } else {
              this.$vs.loading.close()
              this.$vs.notify({
                title: this.$t('MODULES.FailedOperation'),
                text: this.$t('MODULES.errorSearchModulos'),
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'danger'
              })
            }
          })
          .catch(e => {
            this.$vs.loading.close()
            this.$vs.notify({
              title: this.$t('MODULES.FailedOperation'),
              text: this.$t('MODULES.errorSearchModulos'),
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'danger'
            })
            throw new Error(e.message)
          })
      } else if (val.id === 31) {
        await performFetch(this.$store.state.auth.api_url, {
          command: 'module_management_get_module_related_modules',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            module_hash: this.$route.params.moduleHash
          }
        })
          .then(async response => {
            this.$vs.loading.close()
            if (response.status === 200) {
              this.fieldData.relatedItemsModuleOptions = []

              response.json().then(responseData => {
                // this.fieldData.moduleOptions = responseData.modules

                console.log(responseData)

                responseData.modules.forEach(item => {
                  if (item.hash !== this.$route.params.moduleHash) {
                    const moduleObject = {
                      hash: item.hash,
                      name: item.name,
                      type: item.type.id
                    }

                    this.fieldData.relatedItemsModuleOptions.push(moduleObject)
                  }
                })
              })
            } else if (response.status == 401) {
              setApplicationLocalStorageItem(
                'lastUrl',
                btoa(window.location.pathname)
              )
              this.$store.dispatch('auth/signOut')
            } else {
              this.$vs.loading.close()
              this.$vs.notify({
                title: this.$t('MODULES.FailedOperation'),
                text: this.$t('MODULES.errorSearchModulos'),
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'danger'
              })
            }
          })
          .catch(e => {
            console.log(e)
            this.$vs.loading.close()
            this.$vs.notify({
              title: this.$t('MODULES.FailedOperation'),
              text: this.$t('MODULES.errorSearchModulos'),
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'danger'
            })
            throw new Error(e.message)
          })
      }
    },
    validateStep1Add () {
      if (this.fieldData.type.id === 0) {
        this.$vs.notify({
          title: this.$t('MODULES.hashInvalidTitle'),
          text: this.$t('MODULES.typeRequired'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (this.fieldData.type.id === 31 && this.fieldData.rowsOnForm === null) {
        this.$vs.notify({
          title: this.$t('MODULES.hashInvalidTitle'),
          text: this.$t('MODULES.formLinesRequired'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (!this.fieldData.name) {
        this.$vs.notify({
          title: this.$t('MODULES.hashInvalidTitle'),
          text: this.$t('MODULES.nameRequired'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (this.fieldData.showHint && !this.fieldData.hint) {
        this.$vs.notify({
          title: this.$t('MODULES.hashInvalidTitle'),
          text: this.$t('MODULES.showTipSelected'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (
        this.fieldData.type.id === 30 &&
        this.fieldData.moduleOptions.filter(
          x => x.type === 6 && this.integratedKanbans.indexOf(x.hash) === -1
        ).length === 0
      ) {
        this.$vs.notify({
          title: this.$t('MODULES.hashInvalidTitle'),
          text: this.$t('MODULES.noKanbansAvailable'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      return true
    },
    async addFormSubmitted () {
      this.$vs.loading({ type: 'default' })

      const permissionObject = {}

      Object.keys(this.rolePermissions).forEach(item => {
        if (this.rolePermissions[item] === 2) {
          permissionObject[item] = {
            visible: true,
            can_edit: true
          }
        } else if (this.rolePermissions[item] === 1) {
          permissionObject[item] = {
            visible: true,
            can_edit: false
          }
        } else {
          permissionObject[item] = {
            visible: false,
            can_edit: false
          }
        }
      })

      let relatedModuleHash = null

      if (this.fieldData.type.id === 25 || this.fieldData.type.id === 33) {
        relatedModuleHash =
          Object.keys(this.fieldData.relatedModule).length === 0 &&
            this.fieldData.relatedModule.constructor === Object
            ? null
            : this.fieldData.relatedModule.hash
      } else if (this.fieldData.type.id === 31) {
        relatedModuleHash =
          Object.keys(this.fieldData.relatedItemsModule).length === 0 &&
            this.fieldData.relatedItemsModule.constructor === Object
            ? null
            : this.fieldData.relatedItemsModule.hash
      }

      const fieldBody = {
        match_pattern: this.fieldData.matchPattern,
        save_mask: this.fieldData.saveMask,
        concat_identifier: this.fieldData.concatIdentifier,
        name: this.fieldData.name,
        subtitle: this.fieldData.subtitle,
        type_id: this.fieldData.type.id,
        columns_on_form: this.fieldData.columnsOnForm,
        rows_on_form: this.fieldData.rowsOnForm,
        show_hint: this.fieldData.showHint,
        hint: this.fieldData.hint,
        placeholder: this.fieldData.placeholder,
        min_value: this.fieldData.minValue,
        max_value: this.fieldData.maxValue,
        default_value: this.fieldData.defaultValue,
        decimals: this.fieldData.decimals,
        mask: this.fieldData.mask,
        length: this.fieldData.length,
        quick_create: this.fieldData.quickCreate,
        mass_edit: this.fieldData.massEdit,
        show_icon: this.fieldData.showIcon,
        mandatory: this.fieldData.mandatory,
        allow_past_dates: this.fieldData.allowPastDates,
        related_kanban:
          JSON.stringify(this.fieldData.relatedKanban) === '{}'
            ? null
            : this.fieldData.relatedKanban.hash,
        kanban_title_field_hash:
          JSON.stringify(this.fieldData.kanbanTitle) === '{}'
            ? null
            : this.fieldData.kanbanTitle.hash,
        kanban_description_field_hash:
          JSON.stringify(this.fieldData.kanbanDescription) === '{}'
            ? null
            : this.fieldData.kanbanDescription.hash,
        document_name_field:
          JSON.stringify(this.fieldData.documentNameField) === '{}'
            ? null
            : this.fieldData.documentNameField.hash,
        entire_line: this.fieldData.entireLine,
        secret: this.fieldData.secret,
        permissions: permissionObject,
        unique: this.fieldData.unique,
        show_footer: this.fieldData.showFooter,
        show_progress_bar: this.fieldData.showProgressBar,
        related_module_hash: relatedModuleHash,
        related_module_field_hash:
          Object.keys(this.fieldData.relatedField).length === 0 &&
            this.fieldData.relatedField.constructor === Object
            ? null
            : this.fieldData.relatedField.hash,
        has_related_tab: this.fieldData.relatedTab,
        options: this.fieldData.options,
        dependent_field:
          this.fieldData.dependentField !== null
            ? this.fieldData.dependentField.hash
            : null,
        related_tab_name:
          this.fieldData.relatedTabName !== null
            ? this.fieldData.relatedTabName
            : null,
        related_tab_name_en:
          this.fieldData.relatedTabNameEn !== null && this.fieldData.relatedTabNameEn !== ''
            ? this.fieldData.relatedTabNameEn
            : null,
        call_api: this.fieldData.callApi,
        minimal_timeout: this.fieldData.minimalTimeout,
        related_picklist_field:
          JSON.stringify(this.fieldData.picklistField) === '{}' ||
            this.fieldData.picklistField === null
            ? null
            : this.fieldData.picklistField.hash,
        related_picklist_item:
          JSON.stringify(this.fieldData.picklistItem) === '{}' ||
            this.fieldData.picklistItem === null
            ? null
            : this.fieldData.picklistItem.hash,
        is_disabled: this.fieldData.isDisabled,
        is_search_field: this.fieldData.isSearchField
      }

      await performFetch(this.$store.state.auth.api_url, {
        command: 'module_management_add_application_module_field',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: this.$route.params.moduleHash,
          block_token: this.currentBlockToAddField,
          field: fieldBody
        }
      })
        .then(async response => {
          this.$vs.loading.close()
          if (response.status === 200) {
            this.resetProps()
          } else if (response.status == 401) {
            setApplicationLocalStorageItem(
              'lastUrl',
              btoa(window.location.pathname)
            )
            this.$store.dispatch('auth/signOut')
          } else if (response.status === 400) {
            this.$vs.loading.close()
            this.$vs.notify({
              title: this.$t('MODULES.hashInvalidTitle'),
              text: this.$t('MODULES.duplicateFieldName'),
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })
          }
        })
        .catch(e => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('MODULES.FailedOperation'),
            text: this.$t('MODULES.fieldUpdateError'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    }
  }

}
</script>

<style></style>
